import { CLEAR_CLIENT_DETAILS, SET_CLIENT_DETAILS } from '../../../common/constants/reduxConstants'

export const clientSelected = (data: any) => ({
  type: SET_CLIENT_DETAILS,
  data,
})

export const getClientDetails = ({ clientLyraId, cancelToken, providerId }: any) => ({
  action: SET_CLIENT_DETAILS,
  request: {
    method: 'get',
    url: `/v1/clients/${clientLyraId}`,
    params: providerId && { providerId },
    cancelToken,
  },
})

export const clearClientSelected = () => ({ type: CLEAR_CLIENT_DETAILS })
